import { Button } from "@mui/material";
import { styled } from "@mui/system";

const StyledPrimaryButton = styled(Button)(({ theme, styles }) => ({
  width: "100%",
  borderRadius: "16px",
  padding: "10px 24px",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "none",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  boxShadow: theme.shadows[3],
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: theme.shadows[6],
    transform: "scale(1.01)", // Slight zoom on hover
  },
  "&:active": {
    transform: "scale(0.98)", // Press effect
  },
  ...styles,
}));

const PrimaryButton = ({ text = "Log in", styles = {}, onClick }) => {
  return (
    <StyledPrimaryButton styles={styles} onClick={onClick}>
      {text}
    </StyledPrimaryButton>
  );
};

export default PrimaryButton;
